import React, { useContext, useEffect, Fragment } from "react";

import SpotItemV2 from "./SpotItemV2";
import SpotContext from "../../context/spot/spotReviewContext";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import useInfiniteScroll from "../../hooks/useInfiniteScroll";

const PAGE_SIZE = 6;

const Spots = ({ fromPath = '/spots' }) => {
  const spotContext = useContext(SpotContext);

  const { spots, spotsPage, spotsHasMore, getSpots, loading } = spotContext;

  useEffect(() => {
    getSpots(1, PAGE_SIZE, false);
    //eslint-disable-next-line
  }, []);

  const loadMore = () => {
    getSpots((spotsPage || 1) + 1, PAGE_SIZE, true);
  };

  const sentinelRef = useInfiniteScroll(spotsHasMore, loading, loadMore);

  if (spots !== null && spots.length === 0 && !loading) {
    return (
      <Fragment>
        <h4>No spots to show</h4>
      </Fragment>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          gap: 3,
          overflow: 'hidden',
        }}
      >
        {spots && spots.map((spot) => (
          <SpotItemV2 key={spot.id} spot={spot} fromPath={fromPath} />
        ))}
      </Box>
      {spotsHasMore && (
        <Box ref={sentinelRef} sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress size={24} />
        </Box>
      )}
    </Box>
  );
};

export default Spots;
